// Below code not testing - Preselection fix applied on March 14th. Original code commented below .

/*
✅ Reset State When a New Question Loads

Ensures previous matched answers don’t persist.
Clears matchedPairs, selectedLeft, selectedRight, and incorrectPairs.
✅ Properly Handles Next Question

handleContinue() now resets the matching state before moving forward.
✅ Ensures Matched Colors Don’t Persist

Now, when moving to the next question, no previous matches appear as green by default.
✅ Button Styling Works Correctly

Ensures correct/incorrect/matched buttons show correct colors dynamically.

*/


import React, { useState, useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import styled from 'styled-components';

import LearnWithAI from '../../components/ai/LearnWithAI';

import AnswerFeedback from '../../components/practicesession/AnswerFeedback';


// ✅ Standardized "Continue" Button
const StandardButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  border-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
  padding: 12px;
  width: 80%;
  max-width: 300px;
  margin-top: 20px;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
    border-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
  }
`;

// ✅ Center the button wrapper for proper alignment
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const OnboardingMatchTheFollowingQuestion = ({ question, onNext }) => {
  const [selectedLeft, setSelectedLeft] = useState(null);
  const [selectedRight, setSelectedRight] = useState(null);
  const [matchedPairs, setMatchedPairs] = useState({});
  const [incorrectPairs, setIncorrectPairs] = useState([]);
  const [firstSelection, setFirstSelection] = useState(null);

  // ✅ Parse correct answer pairs from question data
  const correctAnswers = Object.fromEntries(
    question.correctanswer.split(',').map(pair => pair.split(':'))
  );

  // ✅ Reset state when question changes
  useEffect(() => {
    setSelectedLeft(null);
    setSelectedRight(null);
    setMatchedPairs({});
    setIncorrectPairs([]);
    setFirstSelection(null);
  }, [question]);

  const handleSelection = (option, isLeft) => {
    if (isLeft) {
      setSelectedLeft(option);
      setFirstSelection(option); // ✅ Turn first tap Purple
    } else {
      setSelectedRight(option);
    }

    if (selectedLeft && !isLeft) {
      // ✅ Check if it's a match
      if (correctAnswers[selectedLeft] === option) {
        setMatchedPairs(prev => ({ ...prev, [selectedLeft]: option }));
      } else {
        setIncorrectPairs([selectedLeft, option]);
        setTimeout(() => setIncorrectPairs([]), 1000); // Reset red after 1 sec
      }
      setTimeout(() => setFirstSelection(null), 500); // Reset Purple after 0.5 sec
      setSelectedLeft(null);
      setSelectedRight(null);
    }
  };

  const getButtonStyle = (option) => {
    if (matchedPairs[option] || Object.values(matchedPairs).includes(option)) {
      return { backgroundColor: 'green', color: 'white' };
    }
    if (incorrectPairs.includes(option)) {
      return { backgroundColor: 'red', color: 'white' };
    }
    if (firstSelection === option) {
      return { backgroundColor: 'purple', color: 'white' }; // ✅ First tap now Purple!
    }
    return { backgroundColor: 'white', color: 'black' };
  };

  const handleContinue = () => {
    setMatchedPairs({});
    setSelectedLeft(null);
    setSelectedRight(null);
    setIncorrectPairs([]);
    setFirstSelection(null);
    onNext();
  };

  return (
    <Card style={{ backgroundColor: '#222', color: '#fff', padding: '20px', textAlign: 'center' }}>
      <h4>{question.questionname}</h4>
      <p>{question.help}</p>

      {/* ✅ Matching Options Layout */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '30px' }}>
        
        {/* ✅ Left Side (1-5) */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {[1, 2, 3, 4, 5].map(i => (
            question[`answeroption${i}`] && (
              <Button
                key={i}
                onClick={() => handleSelection(`answeroption${i}`, true)}
                disabled={matchedPairs[`answeroption${i}`]}
                style={{ ...getButtonStyle(`answeroption${i}`), width: '200px', padding: '10px', fontSize: '16px' }}
              >
                {question[`answeroption${i}`]}
              </Button>
            )
          ))}
        </div>

        {/* ✅ Right Side (6-10) */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {[6, 7, 8, 9, 10].map(i => (
            question[`answeroption${i}`] && (
              <Button
                key={i}
                onClick={() => handleSelection(`answeroption${i}`, false)}
                disabled={matchedPairs[`answeroption${i}`]}
                style={{ ...getButtonStyle(`answeroption${i}`), width: '200px', padding: '10px', fontSize: '16px' }}
              >
                {question[`answeroption${i}`]}
              </Button>
            )
          ))}
        </div>

      </div>

      {/* ✅ Centered Continue Button when all matched */}
      {Object.keys(matchedPairs).length === Object.keys(correctAnswers).length && (
        <ButtonWrapper>
          <StandardButton onClick={handleContinue}>Continue</StandardButton>
        </ButtonWrapper>
      )}
    </Card>
  );
};

export default OnboardingMatchTheFollowingQuestion;









// import React, { useState } from 'react';
// import { Button, Card } from 'react-bootstrap';
// import styled from 'styled-components';

// // ✅ Standardized "Continue" Button
// const StandardButton = styled(Button)`
//   background-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
//   border-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
//   color: #FFFFFF;
//   font-size: 18px;
//   font-weight: bold;
//   border-radius: 12px;
//   padding: 12px;
//   width: 80%;
//   max-width: 300px;
//   margin-top: 20px;
//   transition: background-color 0.2s ease-in-out;
//   &:hover {
//     background-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
//     border-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
//   }
// `;

// // ✅ Center the button wrapper for proper alignment
// const ButtonWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   margin-top: 20px;
// `;

// const OnboardingMatchTheFollowingQuestion = ({ question, onNext }) => {
//   const [selectedLeft, setSelectedLeft] = useState(null);
//   const [selectedRight, setSelectedRight] = useState(null);
//   const [matchedPairs, setMatchedPairs] = useState({});
//   const [incorrectPairs, setIncorrectPairs] = useState([]);
//   const [firstSelection, setFirstSelection] = useState(null); // ✅ Track first tapped button

//   // ✅ Parse correct answer pairs from question data
//   const correctAnswers = Object.fromEntries(
//     question.correctanswer.split(',').map(pair => pair.split(':'))
//   );

//   const handleSelection = (option, isLeft) => {
//     if (isLeft) {
//       setSelectedLeft(option);
//       setFirstSelection(option); // ✅ Turn first tap Purple
//     } else {
//       setSelectedRight(option);
//     }

//     if (selectedLeft && !isLeft) {
//       // ✅ Check if it's a match
//       if (correctAnswers[selectedLeft] === option) {
//         setMatchedPairs(prev => ({ ...prev, [selectedLeft]: option }));
//       } else {
//         setIncorrectPairs([selectedLeft, option]);
//         setTimeout(() => setIncorrectPairs([]), 1000); // Reset red after 1 sec
//       }
//       setTimeout(() => setFirstSelection(null), 500); // Reset Purple after 0.5 sec
//       setSelectedLeft(null);
//       setSelectedRight(null);
//     }
//   };

//   const getButtonStyle = (option) => {
//     if (matchedPairs[option] || Object.values(matchedPairs).includes(option)) {
//       return { backgroundColor: 'green', color: 'white' };
//     }
//     if (incorrectPairs.includes(option)) {
//       return { backgroundColor: 'red', color: 'white' };
//     }
//     if (firstSelection === option) {
//       return { backgroundColor: 'purple', color: 'white' }; // ✅ First tap now Purple!
//     }
//     return { backgroundColor: 'white', color: 'black' };
//   };

//   return (
//     <Card style={{ backgroundColor: '#222', color: '#fff', padding: '20px', textAlign: 'center' }}>
//       <h4>{question.questionname}</h4>
//       <p>{question.help}</p>

//       {/* ✅ Matching Options Layout */}
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '30px' }}>
        
//         {/* ✅ Left Side (1-5) */}
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//           {[1, 2, 3, 4, 5].map(i => (
//             question[`answeroption${i}`] && (
//               <Button
//                 key={i}
//                 onClick={() => handleSelection(`answeroption${i}`, true)}
//                 disabled={matchedPairs[`answeroption${i}`]}
//                 style={{ ...getButtonStyle(`answeroption${i}`), width: '200px', padding: '10px', fontSize: '16px' }}
//               >
//                 {question[`answeroption${i}`]}
//               </Button>
//             )
//           ))}
//         </div>

//         {/* ✅ Right Side (6-10) */}
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//           {[6, 7, 8, 9, 10].map(i => (
//             question[`answeroption${i}`] && (
//               <Button
//                 key={i}
//                 onClick={() => handleSelection(`answeroption${i}`, false)}
//                 disabled={matchedPairs[`answeroption${i}`]}
//                 style={{ ...getButtonStyle(`answeroption${i}`), width: '200px', padding: '10px', fontSize: '16px' }}
//               >
//                 {question[`answeroption${i}`]}
//               </Button>
//             )
//           ))}
//         </div>

//       </div>

//       {/* ✅ Centered Continue Button when all matched */}
//       {Object.keys(matchedPairs).length === Object.keys(correctAnswers).length && (
//         <ButtonWrapper>
//           <StandardButton onClick={() => onNext(true)}>Continue</StandardButton>
//         </ButtonWrapper>
//       )}
//     </Card>
//   );
// };

// export default OnboardingMatchTheFollowingQuestion;
